import { TextField } from 'mui-rff';
import React from 'react';
import { Form } from 'react-final-form';

import { alertError, alertSuccess } from '@dashboard/contexts/SnackbarManager/store';
import buildError from '@dashboard/errors';
import { useCurrentUserQuery, useUpdateUserProfileMutation } from '@dashboard/generated/wp/authentication';
import { Box, Button, Grid, MenuItem, Paper, Stack, Typography } from '@mui/material';
import { TIMEZONE_VALUES } from '@wp-constants/timezones';

type TForm = {
  emailAddress: string;
  timeZone: string;
  name: string;
};

export default function EditUserProfilePage(): JsxNode {
  const { data } = useCurrentUserQuery();
  const [updateUserProfile, { loading }] = useUpdateUserProfileMutation();

  const currentUser = data?.currentUser;

  if (!currentUser) {
    return null;
  }

  async function onSubmit(value: unknown) {
    const { emailAddress, timeZone, name } = value as TForm;
    try {
      await updateUserProfile({ variables: { emailAddress, name, timeZone } });
      alertSuccess('Profile saved');
    } catch (e) {
      const error = buildError(e);
      alertError(error.message);
    }
  }

  const initialValues: TForm = {
    emailAddress: currentUser.emailAddress,
    timeZone: currentUser.timeZone ?? 'America/Los_Angeles',
    name: currentUser.name,
  };
  return (
    <Grid container justifyContent="center" sx={{ my: { xs: 1, md: 3 } }}>
      <Grid item xs={12} md={10} lg={8} xl={7}>
        <Paper sx={{ p: 3 }}>
          <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
            Profile settings
          </Typography>
          <Form
            initialValues={initialValues}
            onSubmit={onSubmit}
            render={({ handleSubmit }) => (
              <form onSubmit={handleSubmit}>
                <Stack>
                  <TextField
                    autoFocus
                    disabled={loading}
                    name="name"
                    label="Full name"
                    fullWidth
                    margin="normal"
                    required
                  />
                  <TextField
                    disabled={loading}
                    name="timeZone"
                    label="Time zone"
                    fullWidth
                    margin="normal"
                    select
                    required
                  >
                    {TIMEZONE_VALUES.map((option, i) => (
                      <MenuItem key={i} dense value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </TextField>
                </Stack>
                <Box mt={2}>
                  <Button disabled={loading} type="submit" variant="contained">
                    Save
                  </Button>
                </Box>
              </form>
            )}
          />
        </Paper>
      </Grid>
    </Grid>
  );
}
